import format from 'date-fns/format';

const dateFieldNames = [
  'sendDateBegin',
  'sendDateEnd',
  'billDateBegin',
  'billDateEnd',
  'salaryPaymentDateBegin',
  'salaryPaymentDateEnd',
  'salaryClosedDateBegin',
  'salaryClosedDateEnd',
];

function serializeDate(value) {
  if (!value || !(value instanceof Date)) return value;
  return format(value, 'yyyy-MM-dd');
}

export default function serializeCriteria(criteria) {
  if (!criteria) return criteria;

  return dateFieldNames.reduce(
    (request, fieldName) => ({
      ...request,
      [fieldName]: serializeDate(criteria[fieldName]),
    }),
    { ...criteria },
  );
}
